// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
    display: flex;
    height: 100%;
    font-family: Arial, sans-serif;
    margin-top: 110px;
   
}

.sidebar {
    width: 200px;
    min-height: 600px;
    background-color: #343a40;
    color: #fff;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.sidebar button {
    background-color: transparent;
    border: none;
    color: #fff;
    font-size: 16px;
    text-align: left;
    padding: 10px;
    cursor: pointer;
    transition: background-color 0.3s;
    font-family: 'Poppins',sans-serif;
}

.sidebar button:hover {
    background-color: #495057;
}

.dashboard-content {
    width: 80%;
    /* padding: 20px; */
    /* background-color: #f8f9fa; */
    margin: 20px 0px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
   
}

.dashboard-content .table-container {
    background-color: #fff;
   
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    width: 90%;
    /* margin-top: -180px; */
    padding:20px;
    margin:20px;
    margin-left:20px;
    margin-right: auto;
    overflow-x: scroll;
    max-height:400px;
}

.table-container h2 {
    margin-bottom: 20px;
    font-family: 'Poppins',sans-serif;
   
}
.dashboard-content .ordered-table {
    width:80%;
    
    border-collapse: collapse;
    overflow: scroll;
    
}

.user-table td {
    padding: 10px;
    border-bottom: 1px solid #dee2e6;
    font-size: 16px;
}

.dashboard-content .ordered-table th,
.dashboard-content .ordered-table td {
    min-width: 200px;
    word-wrap: break;
    padding: 10px;
    border: 1px solid #dee2e6;
    text-align: center;
    font-size: 14px;
    font-family: 'Poppins',sans-serif;
    
    
}

.ordered-table th {
    background-color: #f1f1f1;
    font-weight: bold;
}



.profile-information{
    
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
   
    padding:20px;
}

.profile-information h2{
    font-family: 'Poppins',sans-serif;
}
.profile-information-table{
    display: flex;
    flex-direction: row;
    width:40%;
    border-collapse: collapse;
    padding:20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);

    
}
.profile-information-table tr{
  
}

.profile-information-table th,
.profile-information-table td{
    height:80px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items:center;
    font-family: 'Poppins',sans-serif;
}

.profile-information-table img{
    width:30px;
    height:30px;
}

.address-section{
    display: flex;
    flex-direction: row;
}
.manage-addresses{
    margin-top:0px;
    text-align: left;
    margin :0px 30px;
}

.manage-addresses h2{
    margin:10px 0px;
}

.address-dropdown select{
    height:40px;
    margin-bottom: 10px;
}

.selected-address-card h3{
    margin: 5px 0px;
}

.selected-address-card p{
    margin:10px 0px
}

.selected-address-card button{
    background-color: #fff;
    color:#e42727;
    margin-right:10px;
    cursor: pointer;
}
.selected-address-card button:hover{
    color:#F2C713;
}

.add-address form{
    margin:20px;

}

.form-actions button{
    background-color: #fff;
    color:#e42727;
    cursor: pointer;
    margin-right:10px;

}
.form-actions button:hover{
  color: #F2C713;
}
.address-card button{
    color:#e42727;
    cursor: pointer;
    background-color: #fff;
}
.address-card button:hover{
    color:#F2C713;
}

.dashboard .popup-content{
    width:400px;
    height:auto;
    overflow: scroll;
    margin:20px;
}

.dashboard-filter-container{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width:100%;
    margin:10px;
}

.dashboard-filter-container input{
    width: 20%;
    margin-right:20px;
    height:30px;
}

.dashboard-filter-container button{
    height:30px;
    font-family: 'Poppins',sans-serif;
    font-size:12px;
    background-color: #e42727;
    color:#fff;
    padding:0px 10px;
}

.dashboard-pagination{
    display: flex;
    flex-direction: row;
    margin-top:20px;
    justify-content: center;
    align-items: center;
}

.dashboard-pagination span{
   position: relative;
   top:0px;
   margin:10px;
}


@media screen and (max-width:768px){
    .dashboard {
            display: flex;
            flex-direction: column;
            height: 100%;
            font-family: Arial, sans-serif;
            margin-top: 160px;
            align-items: center;
            text-align: center;
    
        }
      
        .dashboard .sidebar {
            width: 100vw;
            background-color: #343a40;
            color: #fff;
            padding: 10px;
            display: flex;
            flex-direction: row;
            gap: 10px;
            justify-content: space-around;
            align-items: center;
        }
        .dashboard .sidebar button {
            background-color: transparent;
            border: none;
            color: #fff;
            font-size: 12px;
            text-align: left;
            width:fit-content;
            padding: 10px;
            cursor: pointer;
            transition: background-color 0.3s;
            font-family: 'Poppins', sans-serif;
        }
        .dashboard-content{
            display: flex;
            align-items: center;
            width:90%;
        }

        .dashboard-content .table-container {
            background-color: #fff;
    
            border-radius: 8px;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
            width: 90%;
            /* margin-top: -180px; */
            padding: 10px;
            margin: 10px;
            margin-left: 10px;
            margin-right: auto;
            overflow-x: scroll;
        }
        .content .table-container {
            background-color: #fff;
            
            border-radius: 8px;
            box-shadow: 0 10px 10px rgba(0, 0, 0, 0.3);
            width:80%;
            display: block;
            
            
           
    
        }
       
        .sidebar{
            min-height: 80px;
        }
        /* .sidebar {
            width: 20%;
            background-color: #343a40;
            color: #fff;
            padding: 20px;
            display: flex;
            flex-direction: column;
            gap: 15px;
            
        } */

    tr{
        display: flex;
        box-sizing: border-box;
       
        
        
    }

    .ordered-table th,
    .ordered-table td{
        min-width: 200px;
        
        box-sizing: border-box;
    }
 .table-container h2 {
     margin-bottom: 20px;
     font-family: 'Poppins', sans-serif;
     text-align: left;
 }
 .profile-information {
     /* margin-top: -180px; */
     text-align: center;
     display: flex;
     flex-direction: column;
     justify-items: center;
     box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
     /* padding: 20px; */
     width:100%;
     
 }
    
 .profile-information-table{
    display: flex;
    flex-direction: row;
    width:90%;
    margin:5%;
    overflow: scroll;
 }

 .profile-information-table tr{
    display: flex;
    flex-direction: column;
 }

 .profile-information-table td{
    width:100%;
 }
 .address-section {
     display: flex;
     flex-direction: column;
     width:100%;
 }
 .dashboard .popup-content {
     width: 90%;
     height: auto;
     overflow: scroll;
     margin: 20px;
 }

 .dashboard-filter-container {
     display: flex;
     flex-direction: row;
     justify-content: center;
     align-items: center;
     width: 100%;
     margin: 10px;
     height:60px;
 }

 .dashboard-filter-container input {
     width: 40%;
     margin-right: 5px;
     height: 40px;
 }

 .dashboard-filter-container button {
     height: 40px;
     font-family: 'Poppins', sans-serif;
     font-size: 12px;
     background-color: #e42727;
     color: #fff;
     width:40%;
     margin-bottom: 0px;
 }
 .address-card {
     flex-grow: 1;
     flex-shrink: 1;
     flex-basis: calc(50% - 8px);
     min-width: 300px;
     height: 300px;
     display: flex;
     flex-direction: column;
     justify-content: center;
     align-items: center;
     box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
     /* margin:20px; */
     font-family: 'Poppins', sans-serif;
     box-sizing: border-box;
 }
 .dashboard-pagination{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top:0px;
 } 

 .logout-card{
    margin-top: 180px;
 }
}`, "",{"version":3,"sources":["webpack://./src/Styles/userDashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,iBAAiB;;AAErB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,iCAAiC;IACjC,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,+BAA+B;IAC/B,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;;AAE/B;;AAEA;IACI,sBAAsB;;IAEtB,kBAAkB;IAClB,yCAAyC;IACzC,UAAU;IACV,wBAAwB;IACxB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,iCAAiC;;AAErC;AACA;IACI,SAAS;;IAET,yBAAyB;IACzB,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;;;AAGrC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;;;AAIA;;IAEI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;;IAEnB,YAAY;AAChB;;AAEA;IACI,iCAAiC;AACrC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,YAAY;IACZ,uCAAuC;;;AAG3C;AACA;;AAEA;;AAEA;;IAEI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,iBAAiB;;AAErB;AACA;EACE,cAAc;AAChB;AACA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iCAAiC;IACjC,cAAc;IACd,yBAAyB;IACzB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;GACG,kBAAkB;GAClB,OAAO;GACP,WAAW;AACd;;;AAGA;IACI;YACQ,aAAa;YACb,sBAAsB;YACtB,YAAY;YACZ,8BAA8B;YAC9B,iBAAiB;YACjB,mBAAmB;YACnB,kBAAkB;;QAEtB;;QAEA;YACI,YAAY;YACZ,yBAAyB;YACzB,WAAW;YACX,aAAa;YACb,aAAa;YACb,mBAAmB;YACnB,SAAS;YACT,6BAA6B;YAC7B,mBAAmB;QACvB;QACA;YACI,6BAA6B;YAC7B,YAAY;YACZ,WAAW;YACX,eAAe;YACf,gBAAgB;YAChB,iBAAiB;YACjB,aAAa;YACb,eAAe;YACf,iCAAiC;YACjC,kCAAkC;QACtC;QACA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;QACb;;QAEA;YACI,sBAAsB;;YAEtB,kBAAkB;YAClB,yCAAyC;YACzC,UAAU;YACV,wBAAwB;YACxB,aAAa;YACb,YAAY;YACZ,iBAAiB;YACjB,kBAAkB;YAClB,kBAAkB;QACtB;QACA;YACI,sBAAsB;;YAEtB,kBAAkB;YAClB,0CAA0C;YAC1C,SAAS;YACT,cAAc;;;;;QAKlB;;QAEA;YACI,gBAAgB;QACpB;QACA;;;;;;;;;WASG;;IAEP;QACI,aAAa;QACb,sBAAsB;;;;IAI1B;;IAEA;;QAEI,gBAAgB;;QAEhB,sBAAsB;IAC1B;CACH;KACI,mBAAmB;KACnB,kCAAkC;KAClC,gBAAgB;CACpB;CACA;KACI,wBAAwB;KACxB,kBAAkB;KAClB,aAAa;KACb,sBAAsB;KACtB,qBAAqB;KACrB,yCAAyC;KACzC,mBAAmB;KACnB,UAAU;;CAEd;;CAEA;IACG,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAS;IACT,gBAAgB;CACnB;;CAEA;IACG,aAAa;IACb,sBAAsB;CACzB;;CAEA;IACG,UAAU;CACb;CACA;KACI,aAAa;KACb,sBAAsB;KACtB,UAAU;CACd;CACA;KACI,UAAU;KACV,YAAY;KACZ,gBAAgB;KAChB,YAAY;CAChB;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,mBAAmB;KACnB,WAAW;KACX,YAAY;KACZ,WAAW;CACf;;CAEA;KACI,UAAU;KACV,iBAAiB;KACjB,YAAY;CAChB;;CAEA;KACI,YAAY;KACZ,kCAAkC;KAClC,eAAe;KACf,yBAAyB;KACzB,WAAW;KACX,SAAS;KACT,kBAAkB;CACtB;CACA;KACI,YAAyB;KAAzB,cAAyB;KAAzB,2BAAyB;KACzB,gBAAgB;KAChB,aAAa;KACb,aAAa;KACb,sBAAsB;KACtB,uBAAuB;KACvB,mBAAmB;KACnB,uCAAuC;KACvC,iBAAiB;KACjB,kCAAkC;KAClC,sBAAsB;CAC1B;CACA;IACG,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;CACjB;;CAEA;IACG,iBAAiB;CACpB;AACD","sourcesContent":[".dashboard {\n    display: flex;\n    height: 100%;\n    font-family: Arial, sans-serif;\n    margin-top: 110px;\n   \n}\n\n.sidebar {\n    width: 200px;\n    min-height: 600px;\n    background-color: #343a40;\n    color: #fff;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n}\n\n.sidebar button {\n    background-color: transparent;\n    border: none;\n    color: #fff;\n    font-size: 16px;\n    text-align: left;\n    padding: 10px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    font-family: 'Poppins',sans-serif;\n}\n\n.sidebar button:hover {\n    background-color: #495057;\n}\n\n.dashboard-content {\n    width: 80%;\n    /* padding: 20px; */\n    /* background-color: #f8f9fa; */\n    margin: 20px 0px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n   \n}\n\n.dashboard-content .table-container {\n    background-color: #fff;\n   \n    border-radius: 8px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n    width: 90%;\n    /* margin-top: -180px; */\n    padding:20px;\n    margin:20px;\n    margin-left:20px;\n    margin-right: auto;\n    overflow-x: scroll;\n    max-height:400px;\n}\n\n.table-container h2 {\n    margin-bottom: 20px;\n    font-family: 'Poppins',sans-serif;\n   \n}\n.dashboard-content .ordered-table {\n    width:80%;\n    \n    border-collapse: collapse;\n    overflow: scroll;\n    \n}\n\n.user-table td {\n    padding: 10px;\n    border-bottom: 1px solid #dee2e6;\n    font-size: 16px;\n}\n\n.dashboard-content .ordered-table th,\n.dashboard-content .ordered-table td {\n    min-width: 200px;\n    word-wrap: break;\n    padding: 10px;\n    border: 1px solid #dee2e6;\n    text-align: center;\n    font-size: 14px;\n    font-family: 'Poppins',sans-serif;\n    \n    \n}\n\n.ordered-table th {\n    background-color: #f1f1f1;\n    font-weight: bold;\n}\n\n\n\n.profile-information{\n    \n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-items: center;\n    align-items: center;\n   \n    padding:20px;\n}\n\n.profile-information h2{\n    font-family: 'Poppins',sans-serif;\n}\n.profile-information-table{\n    display: flex;\n    flex-direction: row;\n    width:40%;\n    border-collapse: collapse;\n    padding:20px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n\n    \n}\n.profile-information-table tr{\n  \n}\n\n.profile-information-table th,\n.profile-information-table td{\n    height:80px;\n    box-sizing: border-box;\n    display: flex;\n    justify-content: center;\n    align-items:center;\n    font-family: 'Poppins',sans-serif;\n}\n\n.profile-information-table img{\n    width:30px;\n    height:30px;\n}\n\n.address-section{\n    display: flex;\n    flex-direction: row;\n}\n.manage-addresses{\n    margin-top:0px;\n    text-align: left;\n    margin :0px 30px;\n}\n\n.manage-addresses h2{\n    margin:10px 0px;\n}\n\n.address-dropdown select{\n    height:40px;\n    margin-bottom: 10px;\n}\n\n.selected-address-card h3{\n    margin: 5px 0px;\n}\n\n.selected-address-card p{\n    margin:10px 0px\n}\n\n.selected-address-card button{\n    background-color: #fff;\n    color:#e42727;\n    margin-right:10px;\n    cursor: pointer;\n}\n.selected-address-card button:hover{\n    color:#F2C713;\n}\n\n.add-address form{\n    margin:20px;\n\n}\n\n.form-actions button{\n    background-color: #fff;\n    color:#e42727;\n    cursor: pointer;\n    margin-right:10px;\n\n}\n.form-actions button:hover{\n  color: #F2C713;\n}\n.address-card button{\n    color:#e42727;\n    cursor: pointer;\n    background-color: #fff;\n}\n.address-card button:hover{\n    color:#F2C713;\n}\n\n.dashboard .popup-content{\n    width:400px;\n    height:auto;\n    overflow: scroll;\n    margin:20px;\n}\n\n.dashboard-filter-container{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width:100%;\n    margin:10px;\n}\n\n.dashboard-filter-container input{\n    width: 20%;\n    margin-right:20px;\n    height:30px;\n}\n\n.dashboard-filter-container button{\n    height:30px;\n    font-family: 'Poppins',sans-serif;\n    font-size:12px;\n    background-color: #e42727;\n    color:#fff;\n    padding:0px 10px;\n}\n\n.dashboard-pagination{\n    display: flex;\n    flex-direction: row;\n    margin-top:20px;\n    justify-content: center;\n    align-items: center;\n}\n\n.dashboard-pagination span{\n   position: relative;\n   top:0px;\n   margin:10px;\n}\n\n\n@media screen and (max-width:768px){\n    .dashboard {\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n            font-family: Arial, sans-serif;\n            margin-top: 160px;\n            align-items: center;\n            text-align: center;\n    \n        }\n      \n        .dashboard .sidebar {\n            width: 100vw;\n            background-color: #343a40;\n            color: #fff;\n            padding: 10px;\n            display: flex;\n            flex-direction: row;\n            gap: 10px;\n            justify-content: space-around;\n            align-items: center;\n        }\n        .dashboard .sidebar button {\n            background-color: transparent;\n            border: none;\n            color: #fff;\n            font-size: 12px;\n            text-align: left;\n            width:fit-content;\n            padding: 10px;\n            cursor: pointer;\n            transition: background-color 0.3s;\n            font-family: 'Poppins', sans-serif;\n        }\n        .dashboard-content{\n            display: flex;\n            align-items: center;\n            width:90%;\n        }\n\n        .dashboard-content .table-container {\n            background-color: #fff;\n    \n            border-radius: 8px;\n            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n            width: 90%;\n            /* margin-top: -180px; */\n            padding: 10px;\n            margin: 10px;\n            margin-left: 10px;\n            margin-right: auto;\n            overflow-x: scroll;\n        }\n        .content .table-container {\n            background-color: #fff;\n            \n            border-radius: 8px;\n            box-shadow: 0 10px 10px rgba(0, 0, 0, 0.3);\n            width:80%;\n            display: block;\n            \n            \n           \n    \n        }\n       \n        .sidebar{\n            min-height: 80px;\n        }\n        /* .sidebar {\n            width: 20%;\n            background-color: #343a40;\n            color: #fff;\n            padding: 20px;\n            display: flex;\n            flex-direction: column;\n            gap: 15px;\n            \n        } */\n\n    tr{\n        display: flex;\n        box-sizing: border-box;\n       \n        \n        \n    }\n\n    .ordered-table th,\n    .ordered-table td{\n        min-width: 200px;\n        \n        box-sizing: border-box;\n    }\n .table-container h2 {\n     margin-bottom: 20px;\n     font-family: 'Poppins', sans-serif;\n     text-align: left;\n }\n .profile-information {\n     /* margin-top: -180px; */\n     text-align: center;\n     display: flex;\n     flex-direction: column;\n     justify-items: center;\n     box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n     /* padding: 20px; */\n     width:100%;\n     \n }\n    \n .profile-information-table{\n    display: flex;\n    flex-direction: row;\n    width:90%;\n    margin:5%;\n    overflow: scroll;\n }\n\n .profile-information-table tr{\n    display: flex;\n    flex-direction: column;\n }\n\n .profile-information-table td{\n    width:100%;\n }\n .address-section {\n     display: flex;\n     flex-direction: column;\n     width:100%;\n }\n .dashboard .popup-content {\n     width: 90%;\n     height: auto;\n     overflow: scroll;\n     margin: 20px;\n }\n\n .dashboard-filter-container {\n     display: flex;\n     flex-direction: row;\n     justify-content: center;\n     align-items: center;\n     width: 100%;\n     margin: 10px;\n     height:60px;\n }\n\n .dashboard-filter-container input {\n     width: 40%;\n     margin-right: 5px;\n     height: 40px;\n }\n\n .dashboard-filter-container button {\n     height: 40px;\n     font-family: 'Poppins', sans-serif;\n     font-size: 12px;\n     background-color: #e42727;\n     color: #fff;\n     width:40%;\n     margin-bottom: 0px;\n }\n .address-card {\n     flex: 1 1 calc(50% - 8px);\n     min-width: 300px;\n     height: 300px;\n     display: flex;\n     flex-direction: column;\n     justify-content: center;\n     align-items: center;\n     box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n     /* margin:20px; */\n     font-family: 'Poppins', sans-serif;\n     box-sizing: border-box;\n }\n .dashboard-pagination{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-top:0px;\n } \n\n .logout-card{\n    margin-top: 180px;\n }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
